var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchoolBagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0833333333333333,0,0,1.0833333333333333,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("title", null, "school-bag"), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.5,3.75h7a4,4,0,0,1,4,4v15.5a0,0,0,0,1,0,0H4.5a0,0,0,0,1,0,0V7.75a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9,3.75a2.792,2.792,0,0,1,2.935-3,2.815,2.815,0,0,1,2.935,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.707,14.25H4.5a0,0,0,0,1,0,0v9a0,0,0,0,1,0,0H2.707A1.957,1.957,0,0,1,.75,21.293V16.207A1.957,1.957,0,0,1,2.707,14.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.5,14.446h1.793A1.957,1.957,0,0,1,23.25,16.4v4.891a1.957,1.957,0,0,1-1.957,1.957H19.5a0,0,0,0,1,0,0v-8.8A0,0,0,0,1,19.5,14.446Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.5,
    y: 13.5,
    width: 9,
    height: 6.75,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.5,
    y1: 16.5,
    x2: 16.5,
    y2: 16.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12.75,
    y1: 16.5,
    x2: 12.75,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.75,
    y1: 17.185,
    x2: 4.5,
    y2: 17.185
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.5,17.25h3.75"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolBagIcon);
export default __webpack_public_path__ + "static/media/schoolBagIcon.a1e1d7463dcd89bf61d4f0d1e4899a97.svg";
export { ForwardRef as ReactComponent };